import React, { useLayoutEffect, useState } from "react";

import LoadingData from "../Common/LoadingData";
import { setCookie, getCookie } from "../utility/Cookie";

const LoginOld = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isPending, setIsPending] = useState(false);
  const TOKEN = getCookie("_t_");
  const [role, setRole] = useState("");

  useLayoutEffect(() => {
    setRole(getCookie("_r_"));
    setIsPending(true);
    if (TOKEN && role === "Admin") {
      return (window.location.href = "/dashboard/");
    } else if ((TOKEN && role === "Student") || (TOKEN && role === "")) {
      return (window.location.href = "/");
    }
    setIsPending(false);
  }, [TOKEN]);

  const handleLogin = async () => {
    let result = await fetch(`${process.env.REACT_APP_BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
      credentials: "include",
    });
    result = await result.json();
    if (result.code === 200) {
      setCookie("_r_", result.msg.user.role, 1);
      setCookie("_t_", result.msg.token, 1);
      setCookie(
        "_g_",
        JSON.stringify({
          first_name: result.msg.user.first_name,
          last_name: result.msg.user.last_name,
          email: result.msg.user.email,
        }),
        1
      );
      localStorage.setItem("token", result.msg.token);
      localStorage.setItem(
        "_g_user",
        JSON.stringify({
          first_name: result.msg.user.first_name,
          last_name: result.msg.user.last_name,
          email: result.msg.user.email,
        })
      );
      window.location.href = "/dashboard/";
    } else {
      alert(result.status);
    }
  };

  if (isPending) {
    return <LoadingData />;
  }

  return (
    <div className="login-page">
      <div className="login-page-container">
        <h2 className="login-title">Login</h2>
        <div className="login-form">
          <input
            type="text"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <br />
          <input
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <br />
          <button className="contButSmall" onClick={handleLogin}>
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginOld;
